module.exports = __webpack_public_path__ + "c3f877c3c5a6b9ad8f336c9a3d5b4a98.pdf";